import React from "react";

export default function Footer() {
  return (
    <footer
      className="bg-[#0f1620] text-white/80 px-6 md:px-10 pt-20 pb-10"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 pb-16 border-b border-white/10">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <span className="h-8 w-8 rounded-md bg-white text-[#202A36] font-display font-bold text-sm flex items-center justify-center">
                A
              </span>
              <span className="font-display text-xl font-bold text-white tracking-tight">
                Audivis
              </span>
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed">
              Audit-grade financial intelligence tools — built by a Chartered
              Accountant.
            </p>
            <div className="mt-6 flex flex-wrap gap-2 text-[11px] uppercase tracking-[0.18em] font-mono-x">
              {["Ind AS 116", "IFRS 16", "SEBI / IBBI", "CA Built"].map((t) => (
                <span
                  key={t}
                  className="px-2.5 py-1 rounded-full border border-white/15 text-white/70"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {[
            {
              title: "Tools",
              items: [
                { name: "LeaseLens v5", href: "/hub/" },
                { name: "ESOP Valuation", href: "/hub/" },
                { name: "FinConsolidate", href: "/hub/" },
              ],
            },
            {
              title: "Company",
              items: [
                { name: "Story", href: "#story" },
                { name: "Standards", href: "#" },
                { name: "Security", href: "#" },
                { name: "Contact", href: "#" },
              ],
            },
            {
              title: "Legal",
              items: [
                { name: "Privacy", href: "#" },
                { name: "Terms", href: "#" },
                { name: "DPA", href: "#" },
                { name: "Cookies", href: "#" },
              ],
            },
          ].map((col) => (
            <div key={col.title}>
              <div className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-mono-x mb-4">
                {col.title}
              </div>
              <ul className="space-y-3">
                {col.items.map((it) => (
                  <li key={it.name}>
                    <a
                      href={it.href}
                      className="hover:text-white transition-colors text-[15px]"
                      data-testid={`footer-link-${it.name.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {it.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50 font-mono-x uppercase tracking-[0.18em]">
          <span>© {new Date().getFullYear()} Audivis · Made in India</span>
        </div>
      </div>
    </footer>
  );
}
